import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function Dimension({ dimension }) {
    return !(dimension && dimension.value) ? null : (
        <p key={`dimension-${dimension.unit}`}>{dimension.value}</p>
    );
}

Dimension.propTypes = {
    dimension: PropTypes.object,
};

function PdpSharedDetailDimensions({ item }) {
    const dimensions = get(item, 'measurement.dimensions') || [];

    if (!dimensions.length) {
        return null;
    }
    return (
        <span data-tn="pdp-spec-dimensions">
            <Dimension dimension={dimensions.find(dim => dim.unit === 'IN')} />
            <Dimension dimension={dimensions.find(dim => dim.unit === 'CM')} />
        </span>
    );
}

PdpSharedDetailDimensions.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailDimensions, {
    item: graphql`
        fragment PdpSharedDetailDimensions_item on Item {
            measurement {
                dimensions: display(
                    addLabel: true
                    separator: " x "
                    fields: [height, width, depth, diameter]
                ) {
                    unit
                    value
                }
            }
        }
    `,
});
